export type CardapioProduto = {
  id: number;
  nome: string;
  categoria: string;
  descricao: string | null;
  imagem_url: string | null;
  preco_venda: number | null;
  max_quantidade: number;
  unidade_venda?: string;
};

export type CardapioCategoria = {
  nome: string;
  banner_imagem: string | null;
  produtos: CardapioProduto[];
};

export type CardapioPromocao = {
  id: number;
  nome: string;
  valor: number;
  tipo: string;
  subtitulo: string;
  produto_id: number | null;
  max_quantidade: number;
  unidade_venda?: string;
};

export type CardapioCatalogo = {
  empresa: { nome: string; logo_url: string | null };
  categorias: CardapioCategoria[];
  promocoes: CardapioPromocao[];
};

export type CartItem = {
  key: string;
  produto_id: number;
  nome: string;
  descricao: string | null;
  imagem_url: string | null;
  preco_unitario: number;
  quantidade: number;
  observacao: string;
  max_quantidade: number;
  unidade_venda?: string;
};

export type ContaItem = {
  id: number;
  produto_id: number;
  nome_produto: string;
  observacao: string | null;
  quantidade: number;
  preco_unitario: number;
  subtotal: number;
};

export type ClienteCardapio = {
  nome: string;
  whatsapp: string;
};

export function cartItemKey(produtoId: number, observacao: string): string {
  return `${produtoId}::${observacao.trim()}`;
}
